import { MuteText } from '../../elements';
import { DateFormat, DateUtility } from '../../utility';
import { OrderTime } from './common';
import { getWaveHistoryRows } from './wave-merge';

export function WaveHistory({ wave, showRelativeTime = true }) {
  return (
    <div>
      {getWaveHistoryRows(wave).map(row => (
        <div key={row.label} className="mb-1">
          <MuteText>{row.label}</MuteText>
          {row.timestamp ? (
            <div>
              {showRelativeTime ? <OrderTime time={row.timestamp} isEnabled /> : null}
              <div>{DateUtility.formatDate(row.timestamp, DateFormat.barChartMonth)}</div>
            </div>
          ) : (
            <div>—</div>
          )}
          {row.detail ? <MuteText>{row.detail}</MuteText> : null}
        </div>
      ))}
    </div>
  );
}
